import {Component, OnInit} from '@angular/core';
import { CONSTANTES } from '../../../shared/constanst/url-scrolls-header';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html'
})
export class LayoutComponent implements OnInit {

  constructor() {
  }

  public menuData;

  menuDataHeader = {
    data: {
      navigation_menu: [
        {
          menu_items: [
            { label: 'Inicio', url: CONSTANTES.BLOQUE_BIENVENIDA, display: true },
            { label: '¿Quienes somos?', url: CONSTANTES.BLOQUE_QUIENES_SOMOS, display: true },
            { label: 'Legal', url: 'rights_section', display: true },
            { label: 'Socios', url: 'socios', display: true },
            { label: 'Contacto', url: 'scrol_bottom', display: true }
          ]
        }
      ]
    }
  };

  ngOnInit(): void {
  }

}
